// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8701dc61","498":"4fe2f64e","551":"9158d1c0","572":"b8f57c1b","616":"ccab8bb4"}[chunkId] + ".chunk.js";
};